const BhMetricThreeDs = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x={4.167}
      y={2.708}
      width={11.667}
      height={14.583}
      rx={2.5}
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.083 6.667h5.834M7.083 9.792h5.834M7.083 12.917h2.917"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BhMetricThreeDs
